import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailService } from "src/app/services/email.service";

@Component({
    selector: 'app-component-url-not-correct',
    templateUrl: './url-not-correct.component.html',
    styleUrls: ['./url-not-correct.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UrlNotCorrectComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    id: string;

    constructor(
        private router: Router,
        private emailService: EmailService,
        private titleService: Title,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Xác nhận email từ khách hàng");
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    urlNotCorrect() {
        this.emailService.urlNotCorrect(this.id).subscribe(
            res => {
                if (res.isRedirect) {
                    this.router.navigate([res.redirectUrl], { queryParams: { _id: res.id } });
                }
            },
            error => {
                console.log(error);
            }
        )
    }
}